import React from "react";
import useMonitoringRuns from "../../hooks/useMonitoringRuns";
import MonitoringRunCard from "./MonitoringRunCard";

export default function MonitoringRunsPanel({ collectionId, paths, focusRunId, onClose }) {
  const store = useMonitoringRuns(collectionId);
  return (
    <section className="dc-runs-panel" aria-label="Monitoring runs">
      <header className="dc-runs-header">
        <div><span>Traffic data</span><h2>Monitoring runs</h2></div>
        <button type="button" aria-label="Close monitoring history" onClick={onClose}>×</button>
      </header>
      <div className="dc-runs-content">
        {store.error && <div className="dc-error">{store.error}</div>}
        {store.isLoading ? <div className="dc-chart-state">Loading monitoring history…</div>
          : store.runs.length === 0 ? <div className="dc-empty"><strong>No monitoring runs yet</strong><span>Start monitoring to collect time-series traffic data.</span></div>
            : store.runs.map((run, index) => <MonitoringRunCard key={run.id} collectionId={collectionId} run={run} paths={paths} initiallyOpen={run.id === focusRunId || (!focusRunId && index === 0)} />)}
      </div>
    </section>
  );
}

